/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const AIDetectionUserSignals = {
  Installed: "installed",
  Running: "running",
} as const;
export type AIDetectionUserSignals = ClosedEnum<typeof AIDetectionUserSignals>;

/**
 * One enrolled user a detection target was found for, with that user's share of the organization's scan reports: the evidence AIDetection carries for the whole organization, narrowed to one person.
 */
export type AIDetectionUser = {
  /**
   * Distinct devices, by hardware serial, this tool was detected on for this user. Devices that report no serial are not counted.
   */
  deviceCount: number;
  /**
   * When this tool was first detected for this user.
   */
  firstSeen: Date;
  /**
   * When this tool was most recently detected for this user.
   */
  lastSeen: Date;
  /**
   * Detection signals observed for this user: installed and/or running.
   */
  signals: Array<AIDetectionUserSignals>;
  /**
   * Canonical email of the enrolled user the detections are attributed to. Linked alias emails are folded into it.
   */
  userEmail: string;
  /**
   * Unique non-empty detected versions for this user.
   */
  versions: Array<string>;
};

/** @internal */
export const AIDetectionUserSignals$inboundSchema: z.ZodMiniEnum<
  typeof AIDetectionUserSignals
> = z.enum(AIDetectionUserSignals);

/** @internal */
export const AIDetectionUser$inboundSchema: z.ZodMiniType<
  AIDetectionUser,
  unknown
> = z.pipe(
  z.object({
    device_count: z.int(),
    first_seen: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    last_seen: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    signals: z.array(AIDetectionUserSignals$inboundSchema),
    user_email: z.string(),
    versions: z.array(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "device_count": "deviceCount",
      "first_seen": "firstSeen",
      "last_seen": "lastSeen",
      "user_email": "userEmail",
    });
  }),
);

export function aiDetectionUserFromJSON(
  jsonString: string,
): SafeParseResult<AIDetectionUser, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AIDetectionUser$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AIDetectionUser' from JSON`,
  );
}
